var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:['loadingFullPage',{'active':_vm.setOverflow}]},[_c('div',{staticClass:"loadingFullPage__image_container"},[_c('div',{staticClass:"imagebox"},[_c('img',{attrs:{"src":this.imagePath}}),_vm._v(" "),_c('div',{staticClass:"imagebox__text"},[_vm._v(_vm._s(_vm.imageText))])])])])}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-17bb8484","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/utvStore/components/LoadingFullPage.vue
// module id = null
// module chunks = 